import { render } from "./EphemeridesTable.vue?vue&type=template&id=0b3d96f3"
import script from "./EphemeridesTable.vue?vue&type=script&lang=js"
export * from "./EphemeridesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__